<template>
    <div class="content">
        <Header/>

        <div v-if="detail" class="flex">
            <div class="left-main">
                <h1 class="news-title">{{detail.title}}</h1>

                <div class="detail-info f12 c9">
                    <span>{{detail.fPublishTime}}</span>

                    <span v-if="detail.author" class="author">作者：<span>{{detail.author.name}}</span></span>

                    <span v-for="tag in detail.tags" :key="tag.id" class="detail-tag">{{tag.name}}</span>
                </div>

                <div class="content-wrap">
                    <HtmlContent :html="detail.content"/>
                </div>
            </div>


            <div class="right-main">

                <div v-if="recommendsList.length" class="news-simple-list right-item">
                    <p class="f18 fm">相关推荐</p>

                    <ul class="f16">
                        <li v-for="item in recommendsList" :key="item.id" class="el">
                            <a :href="tplGetDetailLink(item.id)">{{item.title2 || item.title}}</a>
                        </li>
                    </ul>
                </div>


                <div class="video-simple-list right-item mt50">
                    <p class="f18 fm">热门视频</p>

                    <ul class="f16 cl">
                        <li v-for="item in hotVideosList" :key="item.id" class="fl">
                            <a :href="tplGetDetailLink(item.id)" class="block rel">
                                <div class="video-poster" :style="tplGetStyle(item)">
                                    <div class="play-mask"></div>
                                </div>

                                <div class="el2 c6 f14 l13 mt4">{{item.title2 || item.title}}</div>
                            </a>
                        </li>
                    </ul>
                </div>

            </div>

        </div>


        <div v-if="isArticleNotExist">

            <p class="f20 ac" style="font-size: 30px; padding: 100px 0 300px; color: #666;">文章不存在或已被删除</p>

        </div>

        <Footer/>
    </div>
</template>
<script>
import Header from 'Components/header'
import Footer from 'Components/footer'
import HtmlContent from '@/components/html-content'
import request from 'Services/axios'
import Utils from "@/utils/utils";

export default {
    data() {
        return {
            id: 0,
            detail: null,

            isArticleNotExist: false,

            recommendsList: [],
            hotVideosList: []

        }
    },
    created() {
        this.id = parseInt(Utils.getQuery().id);
    },
    components: {
        Header,
        Footer,
        HtmlContent
    },

    mounted() {
        this.getData().then(() => {
            this.checkInsertADStatic();
        });
    },

    methods: {

        checkInsertADStatic() {
            const newsIdMap = {
                4935: 'http://e.cn.miaozhen.com/r/k=2272276&p=82kbL&dx=__IPDX__&rt=2&pro=n&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o=',
                4958: 'http://e.cn.miaozhen.com/r/k=2272276&p=82kbM&dx=__IPDX__&rt=2&pro=n&ns=__IP__&ni=__IESID__&v=__LOC__&xa=__ADPLATFORM__&tr=__REQUESTID__&o='
            };

            if (newsIdMap[this.id]) {
                // const script = document.createElement('script');
                // script.src = newsIdMap[this.id];
                // document.getElementsByTagName('head')[0].appendChild(script);

                const image = document.createElement('img');
                image.src = newsIdMap[this.id];
                image.setAttribute("style", "position: absolute; left: 0 ; top: -30000px;");
                document.body.appendChild(image);
            }
        },

        tplGetDetailLink(id) {
            return Utils.getPageUrl('detail', {id})
        },

        tplGetStyle(item) {
            return {backgroundImage: `url("${item.covers}")`}
        },

        getData() {
            return Promise.all([
                this.getDetail(),
                this.detailRecommends(),
                this.getHotVideos()
            ])
        },

        //首页顶部推荐文章
        getDetail() {
            return request({
                url: '/api/web/article/detail.htm?id=' + this.id,
                method: 'get',
            }).then((res) => {
                const data = res.data.data;
                data.fPublishTime = Utils.date(data.publishTime, 'yyyy年MM月dd日 HH:mm')

                if (data.type === 2 && data.summary) {
                    data.content = `<div><p>${data.summary}</p>${data.content}</div>`
                }

                this.detail = data;

            }).catch(error => {
                this.isArticleNotExist = true;
            })
        },

        // 相关推荐
        detailRecommends() {
            return request({url: '/api/web/article/detailRecommends.htm?id=' + this.id}).then((res) => {
                this.recommendsList = res.data.data;
            })
        },

        // 相关推荐
        getHotVideos() {
            return request({url: '/api/web/article/getRanks.htm?type=2&pageSize=5'}).then((res) => {
                const list = res.data.data.filter(a => a.id !== this.id);

                this.hotVideosList = list.slice(0, 4);
            })
        },


    }
};
</script>
<style lang="less" scoped>
.content {
    width: 1196px;
    margin: 0 auto;
}

.left-main {
    width: 856px;

    .news-title {
        font-size: 32px;
        line-height: 1.5;
        font-weight: 400;
    }

    .detail-info {
        padding-bottom: 20px;
        border-bottom: dashed 1px #e9e9e9;
    }

    .author {
        margin: 0 25px;
    }

    .detail-tag {
        border: 1px solid rgba(139, 156, 183, 0.5);
        border-radius: 3px;
        padding: 0 4px;
        margin-right: 15px;

        height: 18px;
        line-height: 16px;

    }

    .content-wrap {
        margin-top: 30px;
    }
}


.right-main {
    width: 300px;
    padding-top: 10px;
    margin-left: 40px;

    .news-simple-list {
        li + li {
            margin-top: 12px;
        }

        li:hover {
            color: #f00;
        }
    }


    .video-simple-list {
        li {
            width: 146px;
            height: 130px;
            margin-bottom: 20px;

            &:nth-child(2n) {
                margin-left: 8px;
            }
        }

        .video-poster {
            width: 146px;
            height: 90px;
            position: relative;
            overflow: hidden;
            background-position: center;
            background-repeat: no-repeat;
            background-size: cover;
        }

        .play-mask {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.4);
            background-image: url('../../assets/img/video-play.png');
            background-size: 30px;
            background-position: center;
            background-repeat: no-repeat;
            transition: all 0.3s;

            &:hover {
                background-color: rgba(0, 0, 0, 0);
                background-image: none;
            }
        }

        .mt4 {
            margin-top: 4px;
        }
    }


}


</style>
